module.exports = __webpack_public_path__ + "static/media/appstore.2a409558.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/appstore.svg
// module id = 1286
// module chunks = 0